<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header"></div>
      <div class="card-margin-bottom">
        <div ref="typeformContainer" style="width: 100%; height: 60vh"></div>
      </div>
      <SnackbarPrompt v-if="errorMessage" icon="warning" variation="warning">
        {{ errorMessage }}
      </SnackbarPrompt>
      <CustomButton :disabled="!quizCompleted" :onClick="action">
        <span v-if="!registerUserIsLoading">Continue</span>
        <LoadingIndicator v-else />
      </CustomButton>
    </div>
  </div>
</template>

<script>
import { EXTERNAL_ROUTES, MODULES } from "@/config";
import CustomButton from "@/components/CustomButton.vue";
import LoadingIndicator from "@/components/LoadingIndicator.vue";
import SnackbarPrompt from "@/components/SnackbarPrompt.vue";
import { mapGetters } from "vuex";
import { createWidget } from "@typeform/embed";
import "@typeform/embed/build/css/widget.css";

export default {
  data() {
    return {
      terms: EXTERNAL_ROUTES.termsAndConditions,
      privacyPolicy: EXTERNAL_ROUTES.privacyPolicy,
      registerUserIsLoading: false,
      errorMessage: null,
      isDataCollectionApproved: false,
      isGpSupportApproved: false,
      quizCompleted: false,
    };
  },
  props: {
    updateFormState: Function,
    action: Function,
    formData: Object,
  },
  components: {
    CustomButton,
    LoadingIndicator,
    SnackbarPrompt,
  },
  mixins: [],
  computed: {
    ...mapGetters(MODULES.WELCOME, {
      onboardingData: "getOnboardingData",
    }),
    ...mapGetters(MODULES.PLAN, {
      availablePlans: "getAvailablePlans",
    }),
  },
  mounted() {
    this.embedTypeform();
  },
  methods: {
    embedTypeform() {
      createWidget("fZNGKS2i", {
        container: this.$refs.typeformContainer,
        hideFooter: true,
        onSubmit: () => {
          this.quizCompleted = true;
        },
      });
    },
  },
};
</script>
